import { useRecordContext, useUpdate } from "ra-core";
import { Checkbox } from "@/components/ui/checkbox";

import type { ProspectActivity } from "../types";

/**
 * Checkbox that toggles an activity's completed_at (now <-> null).
 * Reads the activity from record context, or accepts one via `record`.
 */
export const ActivityDoneToggle = ({
  record: recordProp,
}: {
  record?: ProspectActivity;
}) => {
  const recordFromContext = useRecordContext<ProspectActivity>();
  const record = recordProp ?? recordFromContext;
  const [update, { isPending }] = useUpdate();

  if (!record) return null;

  const handleToggle = () => {
    update("activities", {
      id: record.id,
      data: { completed_at: record.completed_at ? null : new Date().toISOString() },
      previousData: record,
    });
  };

  return (
    <Checkbox
      checked={!!record.completed_at}
      onCheckedChange={handleToggle}
      disabled={isPending}
      aria-label="Mark complete"
      onClick={(e) => e.stopPropagation()}
    />
  );
};
